import React, { createContext, useState, useContext, useCallback } from 'react';

export const NotificationsContext = createContext();

export const NotificationsProvider = ({ children }) => {
    const [message, setMessage] = useState(null);
    const [snackbarProps, setSnackbarProps] = useState({});
    const [alertProps, setAlertProps] = useState({});

    // esta función siempre se puede usar si se quieren poner mensajes de warning o de info
    const setNotificationMessage = useCallback(
        ({
            text = '',
            componentText = null,
            snackbarProps: _snackbarProps,
            alertProps: _alertProps,
        }) => {
            const translatedMessage = text || componentText;
            setMessage(translatedMessage);
            setSnackbarProps(_snackbarProps);
            setAlertProps(_alertProps);
        },
        []
    );

    const deleteNotificationMessage = useCallback(() => {
        setMessage(null);
        setSnackbarProps({});
        setAlertProps({});
    }, []);

    const setSeverity = useCallback(
        (props, severity) => {
            let newProps = { alertProps: { severity }, snackbarProps: {} };
            if (typeof props === 'string') {
                newProps.text = props;
            } else {
                newProps = {
                    ...props,
                    alertProps: {
                        ...props.alertProps,
                        severity: newProps.alertProps.severity,
                    },
                };
            }
            setNotificationMessage(newProps);
        },
        [setNotificationMessage]
    );

    // setErrorMessage y setSuccessMessage son atajos para lo que se prevee que en la práctica se utilizará. Ver ejemplos en notificationsBarHelpers
    // si solo se le pasa como argumento un string, lo traducirá pondrá la severity correspondiente y las defautlProps correspondientes
    const setErrorMessage = useCallback(
        props => {
            setSeverity(props, 'error');
        },
        [setSeverity]
    );

    const setSuccessMessage = useCallback(
        props => {
            setSeverity(props, 'success');
        },
        [setSeverity]
    );

    return (
        <NotificationsContext.Provider
            value={{
                setNotificationMessage,
                setErrorMessage,
                setSuccessMessage,
                message,
                deleteNotificationMessage,
                snackbarProps,
                alertProps,
            }}
        >
            {children}
        </NotificationsContext.Provider>
    );
};

export const useNotification = () => {
    const context = useContext(NotificationsContext);
    if (!context) {
        throw new Error(
            'useNotification debe usarse dentro de un NotificationsProvider'
        );
    }
    return context;
};
